/**
 * @generated SignedSource<<9e679e18b3c55847da4cfc18581316bd>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2

import type { ConcreteRequest } from 'relay-runtime';
export type useSpaceEnabledContentTypesQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type useSpaceEnabledContentTypesQuery$data = {
  readonly space: {
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
    readonly spaceTypeSettings: {
      readonly enabledContentTypes: {
        readonly isBlogsEnabled: boolean;
        readonly isDatabasesEnabled: boolean;
        readonly isEmbedsEnabled: boolean;
        readonly isFoldersEnabled: boolean;
        readonly isLivePagesEnabled: boolean;
        readonly isSlidesEnabled: boolean;
        readonly isWhiteboardsEnabled: boolean;
      };
    };
  } | null | undefined;
};
export type useSpaceEnabledContentTypesQuery = {
  response: useSpaceEnabledContentTypesQuery$data;
  variables: useSpaceEnabledContentTypesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "concreteType": "SpaceTypeSettings",
        "kind": "LinkedField",
        "name": "spaceTypeSettings",
        "plural": false,
        "selections": [
          {
            "concreteType": "EnabledContentTypes",
            "kind": "LinkedField",
            "name": "enabledContentTypes",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isBlogsEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isDatabasesEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isEmbedsEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isLivePagesEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isSlidesEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isWhiteboardsEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isFoldersEnabled"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceEnabledContentTypesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceEnabledContentTypesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "10a6e74201e75f7fd05257845e870e22",
    "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
    "metadata": {},
    "name": "useSpaceEnabledContentTypesQuery",
    "operationKind": "query",
    "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
  }
};
})();

(node as any).hash = "031eb89bf77537fd501cf18345136db8";

export default node;
